// ===============================================================
// File Library — Module Layout with sub-navigation
// ===============================================================

import { Outlet, useLocation } from 'react-router-dom';
import {
  IconGauge, IconFolderOpen, IconSearch, IconCloudUpload, IconTags,
} from '@tabler/icons-react';
import { brand } from '../../lib/colors';
import PageHeader from '../../components/ui/PageHeader';
import ModuleNav from '../../components/layout/ModuleNav';
import type { NavItem } from '../../types/nav';

const NAV_ITEMS: NavItem[] = [
  { label: 'Dashboard', path: '/filelibrary', icon: IconGauge, exact: true },
  { label: 'Browse', path: '/filelibrary/browse', icon: IconFolderOpen },
  { label: 'Search', path: '/filelibrary/search', icon: IconSearch },
  { label: 'Publish', path: '/filelibrary/publish', icon: IconCloudUpload },
  { label: 'Categories', path: '/filelibrary/categories', icon: IconTags },
];

export default function FileLibraryLayout() {
  const { pathname } = useLocation();

  const isDetail = pathname.match(/\/filelibrary\/doc\/\d/);

  const currentPage = NAV_ITEMS.find(item =>
    item.exact ? pathname === item.path : pathname.startsWith(item.path)
  );

  return (
    <div style={{ padding: '24px' }}>
      {!isDetail && (
        <>
          <PageHeader
            breadcrumbs={[{ label: 'Prepare' }, { label: 'File Library' }]}
            title="File Library"
            subtitle="Plans, SOPs and operational document management"
          />
          <ModuleNav items={NAV_ITEMS} accentColor={brand.blurple} />
        </>
      )}
      <Outlet />
    </div>
  );
}
